interface SubmittedIconProps {
  className?: string;
  width?: number;
  height?: number;
  fill?: string;
  fillOpacity?: string | number;
}
import React from "react";

const SubmittedIcon: React.FC<SubmittedIconProps> = ({
  className = "",
  width = 14,
  height = 12,
  fill = "black",
  fillOpacity = "0.2",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M1.34 2.02L6.34667 4.16667L1.33333 3.5L1.34 2.02ZM6.34 7.83333L1.33333 9.98V8.5L6.34 7.83333ZM0.00666666 0L0 4.66667L10 6L0 7.33333L0.00666666 12L14 6L0.00666666 0Z"
        fill={fill}
        fillOpacity={fillOpacity}
      />
    </svg>
  );
};

export default SubmittedIcon;
